import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const CreateWorkTicketAuto = async (data) => {
  try {
    return await postRequest(urls.CREATE_WT_TICKET_AUTO, data);
  } catch (err) {
    return err;
  }
};

export const CreateWorkTicketSingle = async (data) => {
  try {
    return await postRequest(urls.CREATE_WT_TICKET_SINGLE, data);
  } catch (err) {
    return err;
  }
};
